import type { RouteRecordRaw } from 'vue-router';

/** Tenant admin panel. Lives under `/manage/*` on the tenant subdomain
 *  to avoid colliding with the central super-admin console at the
 *  ROOT domain's `/admin/*`. Sidebar copy still labels it "Admin". */
export const adminRoutes: RouteRecordRaw[] = [
  {
    path: 'manage',
    redirect: '/manage/dashboard',
    meta: { requiresAuth: true },
  },
  {
    path: 'manage/dashboard',
    name: 'admin.dashboard',
    component: () => import('./pages/AdminDashboardPage.vue'),
    meta: { title: 'Admin', requiresAuth: true },
  },
  {
    path: 'manage/cash-position',
    name: 'admin.cash-position',
    component: () => import('./pages/CashPositionPage.vue'),
    meta: { title: 'Cash position', requiresAuth: true },
  },
  {
    path: 'manage/team-activity',
    name: 'admin.team-activity',
    component: () => import('./pages/TeamActivityPage.vue'),
    meta: { title: 'Team activity', requiresAuth: true },
  },
  {
    path: 'manage/deliveries',
    name: 'admin.deliveries',
    component: () => import('./pages/FailedDeliveriesPage.vue'),
    meta: { title: 'Failed deliveries', requiresAuth: true },
  },
  {
    path: 'manage/tax-calendar',
    name: 'admin.tax-calendar',
    component: () => import('./pages/TaxCalendarPage.vue'),
    meta: { title: 'Tax calendar', requiresAuth: true },
  },
];
